import React from "react";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillYoutube,
  AiOutlineArrowUp,
} from "react-icons/ai";

import Logo from "../assets/my logo.png";

const Footer = () => {
  return (
    <footer>
      <div>
        <img src={Logo} alt="Founder" />

        <h2>Syed Muqtadeer</h2>
        <p>Motivation is temporary, but discipline last forever.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a
            href="https://www.youtube.com/channel/UCf5Vde4MriyBIkCkiPiCYlg"
            target={"blank"}
          >
            <AiFillYoutube />
          </a>
          <a href="https://www.instagram.com/love_cod_e/" target={"blank"}>
            <AiFillInstagram />
          </a>
          <a href="https://github.com/syedtechnicl/MICLONE" target={"blank"}>
            <AiFillGithub />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
